import { useCallback, useEffect, useState } from 'react';
import { Alert, Button, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { configurarAvisoConcorrencia } from '../../services/api';

/** Sem resposta da pessoa, o pedido devolve o erro à tela (que mostra a mensagem e não fica "gravando" para sempre). */
export const ESPERA_RESPOSTA_MS = 60000;

/**
 * Gravação concorrente (P5, back: docs/integridade-transacional.md): o back devolveu 409 CONCORRENCIA_TENTE_NOVAMENTE
 * depois de repetir a transação. Avisa o motivo e oferece "Tentar de novo", que reenvia o mesmo pedido; a tela que
 * gravou continua esperando, com o que foi digitado (P-Q8: motivo + o que fazer + ação).
 * Vários pedidos ao mesmo tempo entram em fila: um aviso por vez.
 */
export default function AvisoConcorrencia() {
  const [fila, setFila] = useState([]);
  const atual = fila[0] || null;

  useEffect(() => {
    configurarAvisoConcorrencia((pedido) => setFila((f) => [...f, pedido]));
    return () => configurarAvisoConcorrencia(null);
  }, []);

  // A ação roda fora do setState (o React pode chamar o atualizador duas vezes em modo estrito)
  const responder = useCallback((acao) => {
    if (!atual) return;
    setFila((f) => f.slice(1));
    atual[acao]();
  }, [atual]);

  return (
    <Snackbar
      open={Boolean(atual)}
      autoHideDuration={ESPERA_RESPOSTA_MS}
      onClose={(_, motivo) => motivo !== 'clickaway' && responder('desistir')}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity="warning"
        variant="filled"
        data-testid="aviso-concorrencia"
        sx={{ width: '100%', alignItems: 'center' }}
        action={(
          <>
            <Button color="inherit" size="small" onClick={() => responder('tentarDeNovo')} data-testid="aviso-concorrencia-tentar">
              Tentar de novo
            </Button>
            {/* com `action`, o Alert não mostra o X próprio: fechar = desistir (a tela recebe o erro e mostra a mensagem) */}
            <IconButton color="inherit" size="small" aria-label="Fechar" onClick={() => responder('desistir')}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        )}
      >
        {atual?.mensagem}
      </Alert>
    </Snackbar>
  );
}
